import { Fragment, useEffect } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { WrappedSelect } from '@quick/components/Forms';

import { useAppTranslation } from '@/app/i18n/client';

import type { IForm } from './types';

interface ISelectorVehicle {
  vehicles: { id: number; name: string }[];
}

export const SelectorVehicle = ({ vehicles }: ISelectorVehicle) => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext<IForm>();
  const { t } = useAppTranslation(['common', 'demand']);

  useEffect(() => {
    if (vehicles.length === 1)
      setValue('vehicle_type_id', vehicles[0].id, { shouldDirty: true });
  }, [vehicles, setValue]);

  return (
    <Controller
      control={control}
      name="vehicle_type_id"
      shouldUnregister
      rules={{
        required: t('common:msg.required_field'),
      }}
      render={({ field }) => {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        if (vehicles.length === 1) return <Fragment />; // It does not let return null
        return (
          <WrappedSelect
            id="vehicle_type_id"
            requiredMark
            {...field}
            isOnModal
            className="col-start-1"
            label={t('demand:vehicle')}
            error={errors.vehicle_type_id?.message}
          >
            <option hidden value="">
              {t('common:select_option')}
            </option>
            {vehicles?.map(({ id, name }) => (
              <option key={id} value={id}>
                {name}
              </option>
            ))}
          </WrappedSelect>
        );
      }}
    />
  );
};
